"use client";
import { Project1Type } from "@/types/global";
import Image from "next/image";
import Link from "next/link";

interface Props {
    data: Project1Type;
}

const ProjectCardArea2 = ({ data }: Props) => {

    return (
        <>
            <div className="desilo-project-box overflow-hidden">
                <Link href={`/work/${data.url}`}>
                    <div className="desilo-project-thumb overflow-hidden">
                        <Image
                            height={500}
                            width={500}
                            sizes="100vw"
                            src={data.imageUrl}
                            alt={data?.altText || ""}
                            className="w-100 h-100 img_reveal"
                        />
                    </div>
                </Link>
                <Link href={`/work/${data.url}`}>
                    <div className="desilo-project-content">
                        <h3 className="text-color-primary line-clamp-1">
                            <div>{data.title}</div>
                        </h3>
                        <span className="desilo-project-date text-color-primary">
                            {data.category}
                        </span>
                    </div>
                </Link>
            </div>
        </>
    );
};

export default ProjectCardArea2;
